import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import FAQSection from './components/FAQSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <FeaturesSection />
        <CarouselSection />
        <FAQSection />
        <CardsSection />
        <TopicsSection />
        <MediaSection />
        <AboutSection />
        <RankingSection />
        <CommentsSection />
        <IndexSection />
        <UpdatesSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}